import label from './label.json'
import message from './message.json'

export { label, message }
